import { z } from 'zod';

export const CompanyBillingSettings = z.object({
  allowPaymentDueDateAnyDayOfMonth: z.boolean().optional(),
});
export type CompanyBillingSettings = z.infer<typeof CompanyBillingSettings>;

export const DEFAULT_BILLING_SETTINGS: CompanyBillingSettings = {
  allowPaymentDueDateAnyDayOfMonth: false,
};
